import {useAssetsHistoryQuery} from '@domain/assets'
import type {BaseSchedule} from '@domain/schedule'
import {useUpmPlantContext} from '@hconnect/upm'
import {useMemo} from 'react'

import type {MomentRange} from '../types'
import {mapScheduleItemIdToAssetData} from '../utils'

interface AssetHistoryDataByScheduleItemIdParams {
  timeFrame: MomentRange
  schedule: BaseSchedule | undefined
}

export const useAssetHistoryDataByScheduleItemId = ({
  timeFrame,
  schedule
}: AssetHistoryDataByScheduleItemIdParams) => {
  const {plantId} = useUpmPlantContext()
  const {data: assetsHistory} = useAssetsHistoryQuery({
    plantId,
    timeFrame
  })

  return useMemo(() => {
    if (!schedule || !assetsHistory) {
      return undefined
    }
    return mapScheduleItemIdToAssetData(schedule.schedules, assetsHistory)
  }, [schedule, assetsHistory])
}
